import { string, node, oneOf } from 'prop-types'
import Bar from '../../Bar'
import { kuiperClassNames } from '../../utils'

const Footer = ({ align, className, children, color, height }) => (
  <Bar
    className={kuiperClassNames('bar footer', className)}
    align={align}
    height={height}
    color={color}
  >
    {children}
  </Bar>
)

Footer.propTypes = {
  align: string,
  children: node,
  className: string,
  color: string,
  height: oneOf(['small', 'medium', 'large']),
}

export default Footer
